import React, { useState, useEffect } from 'react'

// css
import 'assets/style/elements/nav-prev-next.scss'

import Text from 'components/elements/Text'
import ReactHtmlParser from 'react-html-parser'

function NavPrevNext({ className, nextId, nextTtl, prevId, prevTtl, onClick = () => {} }) {
  return (
    <ul className={'nav-prev-next ' + className}>
      {prevId && (
        <li
          className="prev"
          onClick={() => {
            onClick(prevId)
          }}
        >
          <Text className="left" text="이전" />
          <Text className="right text-ellipsis-1" text={ReactHtmlParser(prevTtl)} />
        </li>
      )}
      {nextId && (
        <li
          className="next"
          onClick={() => {
            onClick(nextId)
          }}
        >
          <Text className="left" text="다음" />
          <Text className="right text-ellipsis-1" text={ReactHtmlParser(nextTtl)} />
        </li>
      )}
    </ul>
  )
}

export default NavPrevNext
